module.exports = __webpack_public_path__ + "img/person_3_index.85a4e263.png";